/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { isElectron } from "react-device-detect";

import { AppRoutes, AuthLevel } from "src/lib/constants";

export enum SignupMethod {
  Email = "email",
  Urbit = "urbit",
}

// these are SSR
export const META_ROUTES = [
  AppRoutes.Meta,
  AppRoutes.Waitlist,
  AppRoutes.WaitlistSuccess,
  AppRoutes.Download,
  AppRoutes.Jobs,
  "/meta/jobs/backend",
  "/meta/jobs/byoj",
  "/meta/jobs/full-stack",
  "/meta/jobs/design",
  "/meta/jobs/frontend",
  AppRoutes.Blog,
  AppRoutes.BlogSignupWithUrbit,
  AppRoutes.BlogFunding2022,
  AppRoutes.BlogTheYear2022,
  AppRoutes.ScribeHome,
  AppRoutes.ScribePrivacy,
  AppRoutes.ScribeFAQ,
  AppRoutes.ScribeAccuracy,
];

export const AUTH_ROUTES = [
  AppRoutes.Signin,
  AppRoutes.SigninUrbit,
  AppRoutes.SigninEmail,
  AppRoutes.ResetPassword,
  AppRoutes.RequestResetPassword,
  AppRoutes.Register,
  AppRoutes.Onboarding,
];

/**
 * Allowed routes specify routes user can visit
 * Default route specifies where they should be redirected if they are trying to access a NOT allowed route
 */
export const AUTH_ROUTE_MAP: Record<AuthLevel, { allowedRoutes: string[]; defaultRoute: string }> = {
  [AuthLevel.Guest]: {
    allowedRoutes: [
      ...META_ROUTES,
      ...AUTH_ROUTES,
      // will verify on [pageSlug] that user has permission or page is public
      AppRoutes.Plate,
      AppRoutes.Profile,
      AppRoutes.Logout,
      AppRoutes.CheckSignInKey,
    ],
    defaultRoute: isElectron ? AppRoutes.Signin : AppRoutes.Meta,
  },
  [AuthLevel.Authorized]: {
    allowedRoutes: [
      ...META_ROUTES,
      AppRoutes.Download,
      AppRoutes.Home,
      AppRoutes.Profile,
      AppRoutes.Settings,
      AppRoutes.Explore,
      AppRoutes.Logout,
      AppRoutes.Plate,
      AppRoutes.Notifications,
    ],
    defaultRoute: AppRoutes.HomeMine,
  },
  [AuthLevel.Onboarding]: {
    allowedRoutes: [...META_ROUTES, ...AUTH_ROUTES],
    defaultRoute: AppRoutes.Register,
  },
};
